export default "__VITE_ASSET__95acf006__"